import React from 'react';
import { chartColors } from './chartColors';
import { useRechartsTheme } from '@/hooks/useRechartsTheme';

interface CustomTooltipProps {
  active?: boolean;
  payload?: Array<{
    name?: string;
    value?: number | string;
    dataKey?: string;
    color?: string;
  }>;
  label?: string;
  formatter?: (value: number | string, name?: string) => [string, string];
}

/**
 * Custom tooltip component for recharts with theme-aware styling.
 * Ensures all text is visible in both light and dark mode.
 */
export const CustomTooltip: React.FC<CustomTooltipProps> = ({ 
  active, 
  payload, 
  label,
  formatter 
}) => {
  const { textColor, tooltipBackground, tooltipBorder } = useRechartsTheme();

  if (active && payload && payload.length) {
    return (
      <div 
        style={{
          backgroundColor: tooltipBackground,
          border: `1px solid ${tooltipBorder}`,
          borderRadius: '8px',
          padding: '10px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
        }}
      >
        {label && (
          <p 
            style={{ 
              color: textColor, 
              fontWeight: 'bold',
              marginBottom: '8px',
              fontSize: '13px'
            }}
          >
            {label}
          </p>
        )}
        {payload.map((entry, index) => {
          const value = entry.value ?? 0;
          const name = entry.name || entry.dataKey || 'Value';
          
          const [formattedValue, formattedName] = formatter 
            ? formatter(typeof value === 'number' ? value : parseFloat(String(value)) || 0, name)
            : [String(value), name];
          
          return (
            <p 
              key={`item-${index}`}
              style={{ 
                color: textColor,
                margin: '4px 0',
                fontSize: '12px'
              }}
            >
              <span style={{ color: entry.color || chartColors.primary, marginRight: '8px' }}>
                ●
              </span>
              <span style={{ fontWeight: 'bold' }}>{formattedName}:</span>{' '}
              <span>{formattedValue}</span>
            </p>
          );
        })}
      </div>
    );
  }

  return null;
};



